module.exports = __webpack_public_path__ + "img/SQL Sync.e0f71a40.svg";